import React, { useEffect } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { motion } from 'framer-motion';
interface LayoutProps {
  children: React.ReactNode;
  currentPage: string;
  onNavigate: (page: string) => void;
}
export function Layout({
  children,
  currentPage,
  onNavigate
}: LayoutProps) {
  // Scroll to top on page change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPage]);
  return <div className="min-h-screen flex flex-col bg-[#0a0a0f] text-gray-100" data-id="element-76">
      <Header currentPage={currentPage} onNavigate={onNavigate} data-id="element-77" />
      <motion.main key={currentPage} initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: -10
    }} transition={{
      duration: 0.3
    }} className="flex-grow pt-20" data-id="element-78">
        {children}
      </motion.main>
      <Footer onNavigate={onNavigate} data-id="element-79" />
    </div>;
}